export default __webpack_public_path__ + "static/v2_andrea_bw-20bc813f26ce21a8f964dc01e11809dd.jpg";